export const accountTypes = [
    {
        label: 'Connect to Divvy',
        value: 'connectDivvy',
        'data-tour': 'connect-divvy-option',
    },
    {
        label: 'Connect to a Bank Account',
        value: 'connectBankAccount',
        'data-tour': 'connect-bank-option',
    },
    {
        label: 'Create Manual Bank Account',
        value: 'createBankAccount',
        'data-tour': 'connect-create-manual-option',
    },
    { label: 'Manage Connections', value: 'manageConnections' },
];
